/**
 * Main Entry Point for Reactive Shopify Theme
 *
 * This file imports all Lit components and initializes the cart store.
 * Vite will bundle this into assets/theme-bundle.js
 */

// Tailwind CSS
import "./tailwind.css";

// Import cart store and initialize
import { initCart } from "./store/cart-store";
initCart();
import {
  productData,
  selectedVariantId,
  selectedVariant,
  isAvailable,
  selectedQuantity,
  activeMediaId,
} from "./store/product-store";
import {
  cartData,
  isCartLoading,
  itemCount,
  isEmpty,
} from "./store/cart-store";
import {
  getCardSignals,
  registerCard,
  changeCardVariant,
} from "./store/collection-store";

// Import all components
import "./components/theme-settings-provider";
import "./components/product-provider";
import "./components/variant-selects";
import "./components/variant-radios";
import "./components/price-pp";
import "./components/badges-pp";
import "./components/product-gallery";
import "./components/add-to-cart";
import "./components/quantity-selector-pp";
import "./components/extended-offer-modal";
import "./components/promo-code-modal";
import "./components/sticky-add-to-cart";
import "./components/ships-by-pp";

// Collection card components
import "./components/card-provider";
import "./components/card-price";
import "./components/card-badge";
import "./components/card-button";
import "./components/card-variant-selector";
import "./components/card-image-switcher";
import "./components/card-ships-by";
import "./components/card-background";
import { initEqualizeCardTitleHeights } from "./utils/equalize-card-title-heights";
initEqualizeCardTitleHeights();
// import "./assets/product-card"; // Legacy product card component (kept for reference)

// Cart components
import "./components/cart-drawer";
import "./components/menu-drawer";
import "./components/cart-item-list";
import "./components/cart-item-row";
import "./components/cart-total";
import "./components/cart-count";
import "./components/cart-count-badge";
import "./components/cross-selling-cart";
import "./components/quantity-selector-cart";

// Expose window.knocking shim for legacy inline scripts (e.g. multicolumn-cbs-deals-box.liquid)
import {
  getTagShippingDate,
  formatToDollarCurrencyString,
} from "./utils/knocking";
(window as any).knocking = {
  getTagShippingDate,
  formatToDollarCurrencyString,
  calculateDiscountPercent(variant: { price: number; compare_at_price: number | null }) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const discount =
        ((variant.compare_at_price - variant.price) * 100) /
        variant.compare_at_price;
      return (window as any).alwaysRoundDown
        ? Math.floor(discount)
        : Math.round(discount);
    }
    return "Exclusive Offer";
  },
};

// Log to confirm the bundle is loaded
console.log("🚀 Reactive theme bundle loaded (Lit + Signals)");

// Dev-only store inspector — use window.__store in the console to read/mutate signals
if (import.meta.env.DEV) {
  (window as any).__store = {
    product: {
      productData,
      selectedVariantId,
      selectedVariant,
      isAvailable,
      selectedQuantity,
      activeMediaId,
    },
    cart: { cartData, isCartLoading, itemCount, isEmpty },
    collection: { getCardSignals, registerCard, changeCardVariant },
  };
  console.log("🔍 __store exposed for debugging");
}

// Export store functions for use in other scripts if needed
// These are available directly from the cart-store module
// export {
//   refreshCart,
//   addToCart,
//   updateCartItem,
//   removeCartItem,
//   clearCart,
//   cartData,
//   itemCount,
//   totalPrice,
//   isEmpty,
//   isCartLoading,
//   isCartOpen,
//   openCart,
//   closeCart,
// } from "./store/cart-store";

// Modal components
import "./components/modal-base";
import "./components/holiday-shipping-modal";
import "./components/confirm-custom-text-modal";

// Holiday shipping components
import "./components/holiday-shipping-countdown";

// Customization components
import "./components/customization-modal";
import "./components/custom-text-input";

// Export initialization functions for Liquid templates
export { initHolidayShipping } from "./store/holiday-store";
export { initCustomization } from "./store/customization-store";
